import React from 'react'
import './Form.css';

const Form = () => {
    return (
        <div>
          
        </div>
    )
}

export default Form